import React from 'react';
import { Link } from 'react-router-dom';
import { Quote } from 'lucide-react';
import { teamHighlights } from '../../data/mock';
import { getOptimizedImageUrl } from '../../lib/utils';

const HighlightsSection = () => {
  return (
    <section data-testid="highlights-section" className="relative py-20 md:py-32 bg-cream overflow-hidden">
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block text-dwarfpony text-sm font-semibold tracking-wider uppercase mb-4">
            Our Stories
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-deepwalnut mb-6">
            Team <span className="text-richolive">Highlights</span>
          </h2>
          <p className="text-heavyrain text-lg max-w-2xl mx-auto">
            Stories of determination, innovation, and breaking barriers
          </p>
        </div>

        {/* Highlights Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {teamHighlights.map((highlight, index) => (
            <Link
              key={index}
              to={`/performance/${highlight.year}`}
              className="block group relative bg-cream border border-pragmatic/30 rounded-2xl overflow-hidden hover:border-dwarfpony hover:shadow-xl transition-all"
            >
              {/* Image */}
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={getOptimizedImageUrl(highlight.image, 800)}
                  srcSet={`
                    ${getOptimizedImageUrl(highlight.image, 400)} 400w,
                    ${getOptimizedImageUrl(highlight.image, 800)} 800w
                  `}
                  sizes="(max-width: 768px) 100vw, 33vw"
                  alt={highlight.title}
                  className="w-full h-full object-contain bg-midnight/5"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-midnight via-transparent to-transparent" />

                {/* Year Badge */}
                <div className="absolute top-4 left-4 bg-gradient-to-r from-dwarfpony to-dwarfpony-dark text-white font-bold px-3 py-1 rounded-full text-sm">
                  {highlight.year}
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <h3 className="text-deepwalnut font-bold text-xl mb-2">{highlight.title}</h3>
                <p className="text-heavyrain text-sm leading-relaxed mb-4">{highlight.description}</p>

                {/* Quote */}
                <div className="relative bg-gradient-to-r from-pragmatic/20 to-richolive/10 rounded-xl p-4 border border-pragmatic/30">
                  <Quote className="absolute -top-2 -left-2 w-6 h-6 text-pragmatic" />
                  <p className="text-deepwalnut text-sm italic pl-4">"{highlight.quote}"</p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HighlightsSection;
